export const API_LOCATION = './api'